import React, { useState } from "react";

import Slider from "react-slick";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";

import { QuickPlayWebSettings } from "@utils/quick-play/slider";
import { BetBuilderPicksSliderItem } from "./components/BetBuilderPicksSliderItem";

export default observer(function BetBuilderPicksHome() {
	const rootStore = useRootAppStore();
	const [isDragging, setIsDragging] = useState(false);

	const betBuilderPresetIds =
		rootStore.quickPlayStore.betBuilderPicksStore.betBuilderPresetIds;

	const settings = {
		...QuickPlayWebSettings,
		infinite: betBuilderPresetIds.length > 3,
		beforeChange: () => setIsDragging(true),
		afterChange: () => setIsDragging(false),
	};

	return (
		<div className="card--carousel__body">
			<Slider
				{...settings}
				className="carousel carousel--most carousel--arrows carousel--arrows--home"
			>
				{betBuilderPresetIds.map((item, index) => {
					const slip =
						rootStore.quickPlayStore.betBuilderPicksStore.BBPicks.get(
							item
						);
					if (!slip) {
						return null;
					}
					return (
						<div
							key={slip.id}
							className="carousel__item carousel--most__item"
						>
							<BetBuilderPicksSliderItem
								BBPick={slip}
								key={slip.id}
								index={index}
								isDragging={isDragging}
								activatePopup={
									rootStore.quickPlayStore
										.betBuilderPicksStore.activatePopup
								}
							/>
						</div>
					);
				})}
			</Slider>
		</div>
	);
});
